export function ExactStamp() {
  return (
    <span className="exact-stamp" title="Valor confirmado do rótulo do produto original">
      <svg viewBox="0 0 12 12" fill="none" aria-hidden="true">
        <path d="M2 6L5 9L10 3" stroke="#5b6e3f" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      exacto
    </span>
  );
}
